import React, { CSSProperties, FC, memo } from "react";

type Props = {
  onRemove: () => void;
  onFind: () => void;
  disabled: boolean;
  isAnnotating: boolean;
  style: CSSProperties;
};

// Pure presentational component - no hooks, no subscriptions
const AnnotationItemMenu: FC<Props> = ({
  onRemove,
  onFind,
  disabled,
  isAnnotating,
  style,
}) => {
  if (isAnnotating) {
    return null;
  }

  if (disabled) {
    return (
      <ul className="annotation-item-menu__container" style={style}>
        <li onClick={onFind}>
          <span className="annotation-item-menu__item bi bi-search" />
        </li>
      </ul>
    );
  }

  return (
    <ul className="annotation-item-menu__container" style={style}>
      <li onClick={onFind}>
        <span className="annotation-item-menu__item bi bi-search" />
      </li>
      <li onClick={onRemove}>
        <span className="annotation-item-menu__item bi bi-trash3" />
      </li>
    </ul>
  );
};

// Custom comparison to prevent unnecessary re-renders
// Only check the values that affect rendering, not function references
const areEqual = (prevProps: Props, nextProps: Props) => {
  return (
    prevProps.disabled === nextProps.disabled &&
    prevProps.isAnnotating === nextProps.isAnnotating &&
    prevProps.style.top === nextProps.style.top &&
    prevProps.style.left === nextProps.style.left
    // Note: onRemove and onFind are intentionally not compared
    // They're stable from useCallback in parent, and comparing functions is expensive
  );
};

export default memo(AnnotationItemMenu, areEqual);
